import moment from 'moment';
import { mapUserProfileToSelectedObject } from '@shared/api/SessionApi';
import { createMiddleware } from '../../shared/redux';
import { LOGGED_USER_REQUEST_SUCCEEDED } from './logged-user.state';
import { getObjectSelected } from '../_redux/pareto-ads-app-redux/action/action';
import { hasLanguageSet, getUserLanguage } from './logged-user.utils';

export const loggedUserMiddlewares = createMiddleware({
    [LOGGED_USER_REQUEST_SUCCEEDED]: (state, action) => {
        const loggedUser = action.payload.data;

        moment.locale(loggedUser.default_language);
        const objectSelected = mapUserProfileToSelectedObject(loggedUser);

        if (hasLanguageSet(loggedUser)) {
            // @ts-ignore
            setTranslate(getUserLanguage(loggedUser));
        }

        return [
            getObjectSelected(objectSelected),
        ];
    },
});
